import { uploadFileContentRecursively } from '../awsHelper';

const createFetchStoreCart = ({
  isAdminCheckout,
  isAuthenticated,
  getGuestCartStorage,
  onShippingCallback,
  fetchUserCart,
  fetchGuestCart,
  fetchAdminCart
}) => (
  identifier,
  {
    ecomStoreCartPackages,
    ecomStoreCartProducts,
    ecomCustomerAddress,
    shippingOptions,
    includeShipping = false,
    removeUnavailable = false,
    skipLoading = false
  } = {},
  onSuccessCallback = null,
  onErrorCallback = null
) => {
  const cart = getGuestCartStorage(identifier);
  const cartPackages = ecomStoreCartPackages || cart.ecomStoreCartPackages;
  const cartProducts = ecomStoreCartProducts || cart.ecomStoreCartProducts;
  const customerShippingAddress = ecomCustomerAddress || cart.shippingAddress;

  const baseOptions = {
    skipLoading,
    ...(includeShipping && {
      ecomCustomerAddress: customerShippingAddress,
      shippingOptions
    })
  };

  const onSuccess = (data) => {
    if (onShippingCallback) {
      onShippingCallback(data.cart.shippingCosts);
    }
    if (onSuccessCallback) {
      onSuccessCallback(data);
    }
  };

  if (isAdminCheckout) {
    return fetchAdminCart(
      identifier,
      {
        ecomStoreCartProducts: cartProducts,
        ecomStoreCartPackages: cartPackages,
        removeUnavailable,
        ...baseOptions
      },
      onSuccess,
      onErrorCallback
    );
  }

  if (isAuthenticated) {
    return fetchUserCart(identifier, baseOptions, onSuccess, onErrorCallback);
  }

  return fetchGuestCart(
    identifier,
    {
      ecomStoreCartProducts: cartProducts,
      ecomStoreCartPackages: cartPackages,
      removeUnavailable,
      ...baseOptions
    },
    onSuccess,
    onErrorCallback
  );
};

const getCartProductError = ({
  ecomStoreProduct,
  ecomStoreCartProductInputAnswers
}) => {
  if (ecomStoreProduct && ecomStoreCartProductInputAnswers) {
    const requiredProductInputs =
      ecomStoreProduct.ecomVendorProduct.ecomVendorProductInputs.filter(
        (i) => i.isRequired
      ) ?? [];

    const requiredInputMissingAnswer = requiredProductInputs.find(
      (i) =>
        !ecomStoreCartProductInputAnswers.find(
          (a) =>
            a.fkEcomVendorProductInput === i.pkEcomVendorProductInput &&
            !!(a.value?.trim() || a.file)
        )
    );
    if (requiredInputMissingAnswer) {
      return `'${requiredInputMissingAnswer.label}' is required`;
    }
  }

  return null;
};

const uploadProductAnswerMedia = (
  identifier,
  ecomStoreCartProducts,
  onSuccessCallback,
  onErrorCallback
) => {
  const productAnswerMedia = ecomStoreCartProducts.flatMap(
    (p, index) =>
      p.ecomStoreCartProductInputAnswers
        ?.filter((a) => !!a.file)
        .map((a) => ({ ...a, uuid: p.uuid, index })) ?? []
  );
  uploadFileContentRecursively(
    productAnswerMedia,
    `${identifier}-product-answer`,
    (mediaData) => {
      const requestedStoreProducts = ecomStoreCartProducts.map((p) => ({...p}));

      mediaData.forEach((a) => {
        const product = requestedStoreProducts.find(
          (p, index) => index === a.index && p.uuid === a.uuid
        );
        const answer = product.ecomStoreCartProductInputAnswers.find(
          (pa) =>
            pa.fkRegFormControlType === a.fkRegFormControlType &&
            pa.fkEcomVendorProductInput === a.fkEcomVendorProductInput
        );
        answer.file = null;
        answer.value = a.src;
      });

      onSuccessCallback(requestedStoreProducts);
    },
    () => {
      onErrorCallback('Failed to upload product media');
    }
  );
};

export { createFetchStoreCart, getCartProductError, uploadProductAnswerMedia };
